// converts globalResponse data to the bdaas format for merchant data
// bdaas format is expected by the current base module components

// getDay function for converting business hours format
const getDay = (day) => {
  let responseDay = 'CLOSED';
  if (day === 'MON') {
    responseDay = 'MONDAY';
  } else if (day === 'TUE') {
    responseDay = 'TUESDAY';
  } else if (day === 'WED') {
    responseDay = 'WEDNESDAY';
  } else if (day === 'THU') {
    responseDay = 'THURSDAY';
  } else if (day === 'FRI') {
    responseDay = 'FRIDAY';
  } else if (day === 'SAT') {
    responseDay = 'SATURDAY';
  } else if (day === 'SUN') {
    responseDay = 'SUNDAY';
  }
  return responseDay;
};

// eslint-disable-next-line complexity
const parseMerchantData = (data) => {
  const merchant = data;
  const contactInformation = {};
  const recommendation = {
    reason: null,
    known_for_text: null,
  };
  if (data.score && data.score.final_score) {
    recommendation.score = data.score.final_score;
  }
  if (data.display_rank) {
    recommendation.rank = data.display_rank;
  }
  if (data.location) {
    const { location } = data;

    if (location.location_name) {
      merchant.name = location.location_name;
    }

    const address = {};

    const addressLines = [];
    if (location.address_line1_text) {
      addressLines.push(location.address_line1_text);
    }
    if (location.address_line2_text) {
      addressLines.push(location.address_line2_text);
    }
    if (location.address_line3_text) {
      addressLines.push(location.address_line3_text);
    }
    if (location.address_line4_text) {
      addressLines.push(location.address_line4_text);
    }
    if (location.address_line5_text) {
      addressLines.push(location.address_line5_text);
    }
    address.address_lines = addressLines;

    if (location.city_name) {
      address.city = location.city_name;
    }
    if (location.country_name) {
      address.country_code = location.country_name;
    }
    if (location.distance) {
      address.distance = location.distance;
    } else {
      address.distance = 0;
    }
    if (location.distance_unit) {
      address.distance_unit = location.distance_unit;
    }
    if (location.longitude && location.latitude) {
      address.latitude = location.latitude;
      address.longitude = location.longitude;
    }
    if (location.postal_code) {
      address.postal_code = location.postal_code;
    }
    if (location.state_name) {
      address.state = location.state_name;
    }
    if (location.phone_number) {
      contactInformation.phone_number = location.phone_number;
    }
    if (location.merchant_url) {
      contactInformation.website = location.merchant_url;
    }

    if (location.merchant_operating_hours) {
      const hours = location.merchant_operating_hours.split(',');
      const operatingHours = {
        monday: [
          [
            'CLOSED',
          ],
        ],
        tuesday: [
          [
            'CLOSED',
          ],
        ],
        wednesday: [
          [
            'CLOSED',
          ],
        ],
        thursday: [
          [
            'CLOSED',
          ],
        ],
        friday: [
          [
            'CLOSED',
          ],
        ],
        saturday: [
          [
            'CLOSED',
          ],
        ],
        sunday: [
          [
            'CLOSED',
          ],
        ],
      };

      hours.forEach((day) => {
        const fullDay = getDay(day.slice(0, 3)).toLowerCase();
        if (day.includes('CLOSED')) {
          operatingHours[fullDay] = [['CLOSED']];
        } else {
          operatingHours[fullDay] = [[day.slice(4, 9), day.slice(10, 15)]];
        }
      });

      merchant.operating_hours = operatingHours;
    }

    merchant.address = address;
  }
  if (data.merchant_categories) {
    const categoryDetails = {};

    const merchantCategories = data.merchant_categories;

    if (merchantCategories.level1_category_description) {
      categoryDetails.name = merchantCategories.level1_category_description;
    }

    if (merchantCategories.level2_category_description) {
      const lvl2Cat = [];
      lvl2Cat.push(merchantCategories.level2_category_description);
      categoryDetails.level_2_categories = lvl2Cat;
    }

    if (merchantCategories.level3_primary_category_description) {
      const lvl3Cat = [];
      lvl3Cat.push(merchantCategories.level3_primary_category_description);
      categoryDetails.level_3_categories = lvl3Cat;
    }

    if (merchantCategories.primary_sic8_description) {
      const sic8Cat = [];
      sic8Cat.push(merchantCategories.primary_sic8_description);
      categoryDetails.sic_8_categories = sic8Cat;
    }

    merchant.category_details = categoryDetails;
  }
  if (data.additional_parameters) {
    const additionalParameters = data.additional_parameters;

    if (additionalParameters.campaign_list_types) {
      merchant.campaign_list_types = additionalParameters.campaign_list_types;
    }

    if (additionalParameters.contactless_pmt_indicator === 'Y') {
      merchant.contactless_payment = true;
    }

    if (additionalParameters.order_option_indicator) {
      merchant.order_option_indicator = additionalParameters.order_option_indicator;
    }

    const badgeDetails = [];
    if (additionalParameters.member_favorite_indicator === 'Y') {
      badgeDetails.push('MEMBER_FAVORITE');
    }
    if (additionalParameters.small_merchant_indicator === 'Y') {
      badgeDetails.push('SHOPSMALL');
    }
    if (additionalParameters.new_merchant_indicator === 'Y') {
      badgeDetails.push('NEW_MERCHANT');
    }
    merchant.badge_details = badgeDetails;
  }
  if (data.encrypted_merchant_identifier) {
    merchant.identifier = data.encrypted_merchant_identifier;
  }
  merchant.contact_information = contactInformation;
  merchant.recommendation = recommendation;

  return merchant;
};

export default parseMerchantData;
